import { BluetoothSvg } from "../../../components/Icons/svgIcons"

const EnableBluetoothModal = () => {
    return (
        <div className="flex items-center gap-2">
            <div className="">
                <BluetoothSvg className="w-16 h-16 stroke-gray-500" />
            </div>
            <div className="flex flex-col justify-between">
                <h3 className="text-xl">Bluetooth disabled</h3>
                <p>Please enable bluetooth to use this app.</p>
            </div>
        </div>
    )
}

export default EnableBluetoothModal